export default "__VITE_ASSET__Cw5jA6YA__"